import React from "react";
import Statistics from "../components/Statistics";
import { useLocation } from "react-router-dom";
import DataTable from "../components/TableComponent";

const Home = () => {
  const location = useLocation();
  const districtData = location.state?.districtData || [];
  
  // Limit to 5000 records
  const limitedData = districtData.slice(0, 5000);

  return (
    <div className="w-full">
      <Statistics />
      <div className="p-2 sm:p-4">
        {districtData.length >= 5000 && (
          <p className="py-2 px-2 mb-2 text-xs md:text-sm bg-red-500 text-white rounded">
            NOTE: Your results exceeded 5,000 records, we are only showing the first 5,000
          </p>
        )}
        <DataTable data={limitedData} />
      </div>
    </div>
  );
};

export default Home;
